import * as React from 'react';
import { PopoverContext } from './Popover.context';
import { PopoverProps } from './Popover.types';
import { usePopover } from './usePopover';

export function Popover(props: PopoverProps) {
    const { children, ...other } = props;
    const popoverContext = usePopover(other);

    return <PopoverContext.Provider value={popoverContext}>{children}</PopoverContext.Provider>;
}
